/*
 * Public API Surface of pepperi-lib/core/layout
 */
export * from './layout.service';
export * from './rtl.directive';
